import type { ParticipantInfo, ParticipantMap, ParticipantMapEntry, VisitorId } from "../store/state/call/reducer";

export const isRecordingLayoutDefined = (participants: ParticipantMap): boolean =>
  Array.from(participants.values()).every((x) => x.isVideoRecorded != null);

export const findOneAndOnlyInterviee = (participants: ParticipantMap): ParticipantMapEntry => {
  let guest: ParticipantMapEntry = null;
  let guestWithVideo: ParticipantMapEntry = null;

  for (const [id, participant] of participants) {
    if (participant.role !== "guest") continue;

    if (guest == null) {
      guest = [id, participant];
      if (participant.isVideoRecorded) {
        guestWithVideo = guest;
      }
    } else {
      guest = null;
      if (participant.isVideoRecorded) {
        if (guestWithVideo) {
          // multiple guests with video enabled, we are done
          return null;
        } else {
          guestWithVideo = [id, participant];
        }
      }
    }
  }

  return guest || guestWithVideo;
};

export const calcRecordingLayoutUpdate = (
  participants: ParticipantMap,
  isVideoRecordedDefault: boolean,
  overrides?: { [key: string]: boolean }
): { visitorId: VisitorId; props: { isVideoRecorded: boolean } }[] =>
  Array.from(participants.entries())
    .map(([visitorId, participant]) =>
      participant.isVideoRecorded != null || !participant.isPresent
        ? null
        : { visitorId, props: { isVideoRecorded: (overrides && overrides[visitorId]) ?? isVideoRecordedDefault } }
    )
    .filter((x) => x);

export const getVideoParticipantIds = (
  participants: ParticipantMap,
  nullIfAllRecorded = false,
  excludeUndefined = false
) => {
  const presentParticipants = Array.from(participants.entries()).filter(
    ([, p]) => p.isPresent && (!excludeUndefined || p.isVideoRecorded != null)
  );
  const ids = presentParticipants.filter(([, p]) => p.isVideoRecorded).map(([id]) => id);
  return nullIfAllRecorded && ids.length === presentParticipants.length ? null : ids;
};

export const sortedParticipantMapEntries = (participants: ParticipantMap, myVisitorId: VisitorId) =>
  Array.from(participants.entries()).sort((a, b) => {
    const valByRole = ([id, p]: [VisitorId, ParticipantInfo]) =>
      id === myVisitorId ? 0 : p.role === "host" ? 1 : p.role === "cohost" ? 2 : 3;
    let res = valByRole(a) - valByRole(b);
    if (!res) {
      res = (a[1].name || "").localeCompare(b[1].name || "");
    }
    return res;
  });

export const getTitleForParticipant = (participant: ParticipantInfo, isSelf: boolean): string => {
  const name = participant.name || "Anonymous";
  const leftCallSuffix = participant.isPresent ? "" : " (left call)";
  const meSuffix = isSelf ? " (me)" : "";
  return `${name}${leftCallSuffix}${meSuffix}`;
};
